module.exports = __webpack_public_path__ + "static/media/LoadingTwo.a137993e.svg";